import { render, staticRenderFns } from "./ObjectTelegramSummary.vue?vue&type=template&id=4b046700&scoped=true&"
import script from "./ObjectTelegramSummary.vue?vue&type=script&lang=js&"
export * from "./ObjectTelegramSummary.vue?vue&type=script&lang=js&"
import style0 from "./ObjectTelegramSummary.vue?vue&type=style&index=0&id=4b046700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b046700",
  null
  
)

export default component.exports